import { JSX } from 'react';

import { Plus } from 'lucide-react';

import { Button } from 'components/Button';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { Undef } from 'types/UtilityTypes';
import { ReferenceCandidate } from 'types/suggestions/LoadBuildingSuggestions';

import { ReferenceTypeOption } from './types';

type ReferenceCandidateRowProps = {
  candidate: ReferenceCandidate;
  // The TMS type the backend suggested, when it is one of the TMS's own types.
  referenceType: Undef<ReferenceTypeOption>;
  onAdd: () => void;
};

// One number in "Other numbers from the email": its suggested type first, the way reps look for a
// reference, then the number.
export function ReferenceCandidateRow({
  candidate,
  referenceType,
  onAdd,
}: ReferenceCandidateRowProps): JSX.Element {
  return (
    <Flex
      align='center'
      justify='between'
      gap='sm'
      className='w-full py-2'
      data-testid='reference-candidate'
    >
      <div className='min-w-0'>
        <Typography variant='body-xs' className='text-neutral-500'>
          {referenceType?.label ?? 'Unlabeled'}
        </Typography>
        <Typography variant='body-sm' weight='medium' className='truncate'>
          {candidate.number}
        </Typography>
      </div>
      <Button
        type='button'
        variant='ghost'
        size='xs'
        className='shrink-0 text-brand-500'
        aria-label={
          referenceType
            ? `Add ${candidate.number} as ${referenceType.label}`
            : `Add ${candidate.number}`
        }
        onClick={onAdd}
        // ReferenceCandidates records the add.
        buttonNamePosthog={null}
      >
        <Plus className='h-3 w-3' />
        Add
      </Button>
    </Flex>
  );
}
